module.exports = __webpack_public_path__ + "static/media/logo-company-login-tc.bf2e28ca.png";